// Layout constants
export const LAYOUT = {
  WEBSITE_WIDTH: '1920px',
  WEBSITE_HEIGHT: '2751px',
  CONTENT_WIDTH: '1762px',

  TOP_BAR: {
    HEIGHT: '42px',
    WIDTH: '1762px'
  },

  HEADER_BANNER: {
    HEIGHT: '155px',
    WIDTH: '1762px'
  },

  MENU_BUTTON: {
    WIDTH: '181px',
    HEIGHT: '49px'
  },

  SLIDER: {
    WIDTH: '1759px',
    HEIGHT: '607px',
    DESCRIPTION: {
      WIDTH: '732px',
      HEIGHT: '181px'
    }
  },

  WELCOME: {
    IMAGE: {
      WIDTH: '286px',
      HEIGHT: '448px'
    },
    CARD: {
      WIDTH: '921px',
      HEIGHT: '449px'
    },
    SIDEBAR_CARD: {
      WIDTH: '250px',
      HEIGHT: '448px'
    }
  },

  NEWS_EVENTS: {
    HEADER: {
      WIDTH: '856px',
      HEIGHT: '66px'
    },
    CONTAINER: {
      WIDTH: '1750px',
      HEIGHT: '712px'
    },
    CARD: {
      WIDTH: '395px',
      IMAGE: {
        HEIGHT: '258px'
      },
      DESCRIPTION: {
        HEIGHT: '309px'
      }
    }
  },

  FOOTER: {
    CONTENT: {
      WIDTH: '1753px',
      HEIGHT: '478px'
    },
    CONTACT_FORM: {
      WIDTH: '320px',
      HEIGHT: '371px'
    },
    RELATED_LINKS: {
      WIDTH: '246px',
      HEIGHT: '158px'
    },
    CONTAINER: {
      WIDTH: '1753px',
      HEIGHT: '69px'
    }
  },

  LOGO: {
    LEFT: {
      WIDTH: 112,
      HEIGHT: 130
    },
    RIGHT: {
      WIDTH: 125,
      HEIGHT: 123
    }
  }
} as const;